import React from "react";
import QRCode from "react-qr-code";

interface QRGeneratorProps {
    value: string;  // S�rg for at denne prop er defineret
    size?: number;
}

const QRGenerator: React.FC<QRGeneratorProps> = ({ value, size = 200 }) => {
    return (
        <div className="flex flex-col items-center">
            <QRCode value={value} size={size} />
        </div>
    );
};

export default QRGenerator;
